"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdfRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const replaceUnsupportedDocumentNodes_1 = require("./utils/replaceUnsupportedDocumentNodes");
const PlatformAdfRenderer = 'AdfRenderer';
const AdfRenderer = (props) => {
    const { replaceUnsupportedNode, document, ...adfRendererProps } = props;
    const documentWithMedia = replaceUnsupportedNode
        ? (0, replaceUnsupportedDocumentNodes_1.replaceUnsupportedDocumentNodes)(document, replaceUnsupportedNode)
        : document;
    const documentWithoutMedia = replaceUnsupportedNode
        ? (0, replaceUnsupportedDocumentNodes_1.replaceUnsupportedMediaNodes)(documentWithMedia, replaceUnsupportedNode)
        : documentWithMedia;
    return ((0, jsx_runtime_1.jsx)(PlatformAdfRenderer, { ...adfRendererProps, document: documentWithMedia, documentWithoutMedia: documentWithoutMedia }));
};
exports.AdfRenderer = AdfRenderer;
